export default {
  upload_common: {
    required: 'Cette question est obligatoire',
    max_length_500: 'Veuillez répondre en 500 mots.',
    please_enter_a_number: 'Entrer des chiffres',
    unexpected_error: "Une erreur inattendue s'est produite",
    temporarily_saved: 'Enregistré',
    unanswered_items: 'Il y a pas de questions sans réponse',
    answer_questionnaire_select: 'Sélectionner une enquête',
    entry: 'Veuillez écrire votre réponse',
    target_select: 'Sélectionner',
    value_unit: 'Chiffre',
    unit: 'Unité',
    attach_documents: 'Joindre les fichiers',
    textarea_placeholder: 'Veuillez écrire votre réponse si nécessaire, ou si vous souhaitez ajouter des explications supplémentaires.',
    temporary_storage: 'Enregistrer',
    submit: 'Soumettre',
    last_saved_temporary: 'Dernière mise à jour',
    There_are_unanswered_questions: 'Il y a pas de questions sans réponse',
    submitted_text: 'Cette enquête a été soumise.',
    submitted_at: 'Date de soumission',
    withdrawal_of_answer: 'Soumission de retrait',
    withdrawal_accepted: 'Retrait accepté',
    help: 'Aide',
    example_of_evidence: 'Exemple de preuve',
    save_temporary_answer: "Enregistrer l'enquête",
    saved_temporary_answer: 'Votre réponse a été enregistrée.',
    submit_answer: "Soumettre l'enquête",
    confirm_submit_answer: "Voulez-vous vraiment soumettre l'enquête ?",
    confirm_submit_shared_text: "\nVos réponses à l'enquête seront communiquées à votre acheteur.",
    complete_submit_answer: "L'enquête a été soumise. \nMerci de votre collaboration.",
    back_answer: 'Retourner',
    close: 'Fermer',
    save_temporary_answer_and_prev: 'Enregistrer et revenir à la page précédente',
    save_temporary_answer_and_next: 'Enregistrer et aller à la page suivante',
    prev: 'Retour',
    next: 'Suivant',
    question_group_question_download: "Télécharger l'enquête",
    question_group_answer_download: 'Télécharger les réponses',
    question_group_download_answer_csv_title: 'Question・Réponse(CSV)',
    question_group_download_answer_csv_description: 'Télécharger les réponses en csv.',
    question_group_download_answer_pdf_title: 'Question・Réponse(PDF)',
    question_group_download_answer_pdf_description: 'Télécharger les réponses en pdf.',
    question_group_download_scorecard_pdf_title: 'Fiche de notation(PDF)',
    question_group_download_scorecard_pdf_description: 'Télécharger le score en pdf.',
    question_group_download_esg_award_svg_title: 'Prix ESG(SVG)',
    question_group_download_esg_award_svg_description: 'Télécharger le prix en svg.',
    question_group_download_esg_award_pdf_title: 'Prix ESG(PDF)',
    question_group_download_esg_award_pdf_description: 'Télécharger le prix en pdf.',
    request_survey_withdrawal: 'Demander le retrait de l’enquête',
    survey_withdrawal_description: 'La demande de retrait sera envoyée à votre acheteur.Veuillez indiquer ci-dessous la raison pour laquelle vous souhaitez retirer votre enquête. \nLes détails de votre demande seront communiqués à votre acheteur.',
    reason_withdrawal_request: 'Motif de la demande de retrait',
    completed_withdrawal_request: "Votre demande de retrait a été acceptée. Veuillez patienter jusqu'à ce qu'elle soit approuvée.",
    send: 'Envoyer',
    cancel: 'Annuler',
    balloon_title_withdrawal_request: 'Votre demande de retrait a été acceptée. ',
    no_survey: "Il n'y a pas de demande d'enquête disponible.",
    failed_to_save_before_export: "L'enregistrement temporaire avant le téléchargement du fichier a échoué. Vérifiez que les informations saisies sont correctes",
    filter_unfilled_questions: 'Afficher uniquement les enquêtes sans réponse',
    no_unfilled_questions: "Il n'y a pas de questions sans réponse",
    move_page: 'Aller à la page suivante',
    confirm_move_page_message: 'Vos réponses ne sont pas enregistrées. \nSi vous passez à une autre page, vos réponses seront perdues.Voulez-vous enregistrer vos réponses avant de passer à la page suivante ?',
    confirm_without_save: 'Ne pas enregistrer',
    confirm_with_save: 'Enregistrer',
    error_save: 'Impossible d’enregistrer temporairement. Vérifiez vos réponses.',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: "Enquête en cours d'édition",
    unable_edit_someone_editing_survey: "L'enquête ne peut pas être éditée pour le moment, car un utilisateur est en train de l'éditer.",
    user_editing_survey: "est en train d'éditer.",
    reference_question: {
      // see_previous_answers: "",
      previous_answers: 'Réponses précédentes',
      // overwrite_with_previous_answers: "",
      submitted_at: '(Soumis le {submitted_at})',
      // related_question: "",
      click_to_expand: 'Cliquer pour développer',
      click_to_omit: 'Cliquer pour omettre',
      // description: "",
      answer_reference_function: 'Fonction de référence de la réponse',
      overwrite: 'Remplacer',
      overwrite_confirm: 'Cette action remplit les réponses précédentes pour les questions qui ont été répondues dans des enquêtes antérieures.\nToutes les questions qui ont déjà été répondues seront remplacées.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Élément',
      activity_amount: 'Montant',
      emission_factor: "Facteur d'émission",
      emission_amount: 'Émissions',
      unit_sale: "Intensité d'émission",
      total: 'Total',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/un million de YEN',
    },
    label: {
      required_answer: 'Réponse obligatoire',
      optional_answer: 'Réponse facultative',
      conditional_required_answer: 'Branchements de la réponse obligatoire',
      note: 'Remarques',
      // evidence_attachments: "",
    },
    // no_available_in_pdf: "",
    // comparison_question_meta: "",
    question_group_download_answered_csv_title: 'Question・Réponse(CSV)',
    question_group_download_answered_pdf_title: 'Question・Réponse(PDF)',
  },
}
